/**
 * FXBenchmark
 * - Tag: 3073
 * - FIX Specification type: int
 * - Mapped type: number
 * @readonly
 * @public
 */
export const FXBenchmark = Object.freeze({
    Bloomberg: 1,
    /** Central Bank */
    CentralBank: 2,
    /** WMR */
    WMR: 3,
    MitsubishiUFJ: 4,
    LondonBullionMarketAssociation: 5,
    LondonMetalExchange: 6,
    Other: 99,
} as const);

export type FXBenchmark = (typeof FXBenchmark)[keyof typeof FXBenchmark];
